import { render, staticRenderFns } from "./ExamPaperSet.vue?vue&type=template&id=4279134e&scoped=true&"
import script from "./ExamPaperSet.vue?vue&type=script&lang=js&"
export * from "./ExamPaperSet.vue?vue&type=script&lang=js&"
import style0 from "./ExamPaperSet.vue?vue&type=style&index=0&id=4279134e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279134e",
  null
  
)

component.options.__file = "ExamPaperSet.vue"
export default component.exports